import { FC } from 'react';

import { TireInspectionDialog, TireInspections, useTireInspections } from '.';

const TireField: FC<{ tire: keyof TireInspections }> = ({ tire }) => {
  const { tires, selectTire } = useTireInspections();
  return (
    <div className="badge-container">
      <button
        type="button"
        className="btn-outline flex-row justify-content-evenly text-info-main w-100"
        onClick={() => selectTire(tire)}
        data-cy={`${tires[tire]?.axle}-${tires[tire]?.centrality}-${tires[tire]?.side}-tire-button`}
      >
        <label className="text-md">{tire.match(/[a-z]+/)?.[0]?.toUpperCase()}</label>
        {!tires[tire]?.measurement0 ? null : <span>{tires[tire]?.measurement0} / 32"</span>}
      </button>
      {!tires[tire]?.damageType ? (
        !tires[tire]?.measurement0 ? null : (
          <span className="badge bg-white icon-large material-icons p-0 text-info-main">check_circle</span>
        )
      ) : (
        <span className="badge bg-white icon-large material-icons p-0 text-secondary">build_circle</span>
      )}
    </div>
  );
};

const TireInformation: FC = () => {
  const { triaxle } = useTireInspections();
  const tireKeys: (keyof TireInspections)[][] = [
    ['frontLeftOutside', ...Array(Number(!!triaxle)).fill('centerLeftOutside'), 'rearLeftOutside'],
    ['frontLeftInside', ...Array(Number(!!triaxle)).fill('centerLeftInside'), 'rearLeftInside'],
    ['frontRightInside', ...Array(Number(!!triaxle)).fill('centerRightInside'), 'rearRightInside'],
    ['frontRightOutside', ...Array(Number(!!triaxle)).fill('centerRightOutside'), 'rearRightOutside']
  ];
  return (
    <div id="transaction-tires">
      <TireInspectionDialog />
      <div className="grid-4">
        <p className="col-start-1 row-start-1 text-primary-dark font-weight-bold">OUTSIDE LEFT</p>
        <p className="col-start-2 row-start-1 text-primary-dark font-weight-bold">INSIDE LEFT</p>
        <p className="col-start-3 row-start-1 text-primary-dark font-weight-bold">INSIDE RIGHT</p>
        <p className="col-start-4 row-start-1 text-primary-dark font-weight-bold">OUTSIDE RIGHT</p>
        {tireKeys.reduce(
          (acc, keys, i) =>
            acc.concat(
              keys.map((axle: keyof TireInspections, j) => (
                <div key={axle} className={`col-start-${i + 1} row-start-${j + 2}`}>
                  <TireField tire={axle} />
                </div>
              ))
            ),
          [] as JSX.Element[]
        )}
      </div>
    </div>
  );
};

export default TireInformation;
